import { BehaviorSubject } from 'rxjs';
import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';

import { Station } from '../../core';
import { ElasticSearchHit } from '../../search-keywords/transcription-search.service';
import { AudioPlayerComponent, IMediaStream } from '../audio-player';

declare var dataLayer;

@Component({
  selector: 'app-player-sidenav',
  templateUrl: './player-sidenav.component.html',
  styleUrls: ['./player-sidenav.component.scss']
})
export class PlayerSidenavComponent {

  private SKIP_FIVE_SECONDS = 5;

  @ViewChild(forwardRef(() => AudioPlayerComponent), { static: true })
  private audioPlayer: AudioPlayerComponent;

  events: string[] = [];
  private opened: boolean;
  reason = '';

  stationLogo = 'https://i.iheart.com/v3/re/assets/images/3544.png';
  private placeholder = 'https://via.placeholder.com/220x220?text=N/A';
  playerSream: IMediaStream;

  stationIdObservable: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  @Input()
  title = '';

  @Output()
  expandOrCollapseEventEmitter: EventEmitter<boolean> = new EventEmitter();

  stationDetails: Station = null;
  rawTranscription: String = null;
  showBadge:boolean = false;

  hit: ElasticSearchHit = null;

  constructor(private _sidenav: MatSidenav, private router: Router) {
    this._sidenav.mode = 'side';
  }

  downloadAudio() {
    this.close('downloads');
    this.router.navigate(['downloads'], {
      queryParams: {
        stationId: this.stationDetails.id,
        entStationId: this.stationDetails.enterpriseStationId,
        segmentStartTime: this.hit.segmentStartTime,
        currentTime: this.audioPlayer.api.currentTime,
      }
    });
    try {
      dataLayer.push({
        'event': 'click-transcription-audio-download',
        'operation': 'transcription-download-audio'
      });
    } catch (e) {}
  }


  close(reason?: string) {
    this.showBadge = false;
    this.reason = reason;
    this._sidenav.close();
    this.opened = false;
    this.pause();
    this.expandOrCollapseEventEmitter.emit(this.opened);
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
  }

  open(station: Station, playlistURL: string, autoPlay: boolean = false,
    rawTranscription: String = null,
    audioPositionSeconds: Number = null, playFromStart: Boolean = false, hit: ElasticSearchHit = null) {
    this.stationDetails = station;
    this.stationIdObservable.next([this.stationDetails.id]);
    this.hit = hit;
    this.rawTranscription = rawTranscription;
    if (station) {
      this.stationLogo = station.stationLogoUrl;
    } else {
      this.stationLogo = this.placeholder;
    }
    if (playlistURL) {
      const mediaStream: IMediaStream = {
        type: 'hls',
        source: playlistURL,
        label: 'Label'
      };

      const token = localStorage.getItem('msal.idtoken');
      if (audioPositionSeconds && !playFromStart) {
        const skipTo = audioPositionSeconds.valueOf();
        const skipToFiveSeconds = skipTo - this.SKIP_FIVE_SECONDS > 0 ? skipTo - this.SKIP_FIVE_SECONDS : 0;
        this.audioPlayer.playStream(mediaStream, skipToFiveSeconds, autoPlay, token);
      } else {
        // Resetting the player original pos
        this.audioPlayer.playStream(mediaStream, 0, autoPlay, token);
      }

    }
    this._sidenav.open();
    this.opened = true;
    this.expandOrCollapseEventEmitter.emit(this.opened);
    this.showBadge = true;
  }

  isPlaying(stationId: String = null): boolean {
    let playing: boolean = this.audioPlayer && this.audioPlayer.isPlaying();

    if (stationId && this.stationDetails && this.stationDetails.id) {
      playing = playing && stationId === this.stationDetails.id;
    }

    return playing;
  }

  isOpened(stationId: String = null): boolean {
    let opened: boolean = this.opened;

    if (stationId && this.stationDetails && this.stationDetails.id) {
      opened = opened && stationId === this.stationDetails.id;
    }

    return opened;
  }


  play() {
    if (this.audioPlayer) {
      this.audioPlayer.play();
      try {
        dataLayer.push({
          'event': 'click-transcription-audio-play',
          'operation': 'transcription-play-audio'
        });
      } catch (e) {}
    }
  }

  pause() {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
    }
  }

  setPlaceholderImage() {
    this.stationLogo = 'assets/images/no-image-placeholder.jpg';
  }

}
